<app-banner [title]="'Rendez-vous'" [links]="links"></app-banner>

<div class="container mx-auto px-4 py-6">

	<div class="flex items-center gap-x-7 mb-4">
		<label class="text-gray-500" for="">Rechercher : </label>
		<input type="search" name="" class="input placeholder:text-gray-400 text-gray-800" placeholder="Rechercher ..."
			id="">
	</div>
	<!-- Loading state -->
	<div *ngIf="loading" class="overflow-x-auto rounded-lg border border-gray-200 bg-white shadow mt-7">
		<div class="flex items-center justify-center py-12">
			<div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
			<span class="ml-3 text-gray-600">Chargement des rendez-vous...</span>
		</div>
	</div>

	<!-- Table -->
	<div *ngIf="!loading" class="overflow-x-auto rounded-lg border border-gray-200 bg-white shadow mt-7">
		<table class="w-full">
			<!-- head -->
			<thead>
				<tr class="bg-gray-100 border-b border-gray-200">
					<th class="text-left py-3 px-4 text-sm font-semibold text-gray-900">Date</th>
					<th class="text-left py-3 px-4 text-sm font-semibold text-gray-900">Créneau</th>
					<th class="text-left py-3 px-4 text-sm font-semibold text-gray-900">Patient</th>
					<th class="text-left py-3 px-4 text-sm font-semibold text-gray-900">Professionnel consultant</th>
					<th class="text-left py-3 px-4 text-sm font-semibold text-gray-900">Lieu du rendez-vous</th>
					<th class="text-left py-3 px-4 text-sm font-semibold text-gray-900">Statut</th>
					<th class="text-left py-3 px-4 text-sm font-semibold text-gray-900">Motif</th>
					<th class="text-left py-3 px-4 text-sm font-semibold text-gray-900"></th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let appointment of paginatedAppointments" class="hover:bg-gray-50 border-b border-gray-100">
					<td class="py-3 px-4 text-sm text-gray-900 font-medium">
						{{ appointment.date | date:'dd/MM/yyyy' }}
					</td>
					<td class="py-3 px-4 text-sm text-gray-900">{{ appointment.slot }}</td>
					<td class="py-3 px-4 text-sm text-gray-900 font-medium">{{ appointment.patient }}</td>
					<td class="py-3 px-4 text-sm text-gray-900">{{ appointment.professional }}</td>
					<td class="py-3 px-4 text-sm text-gray-900">{{ appointment.location }}</td>
					<td class="py-3 px-4">
						<span [class]="getStatusBadgeClass(appointment.status)">
							{{ getStatusText(appointment.status) }}
						</span>
					</td>
					<td class="py-3 px-4 text-sm text-gray-900 max-w-xs truncate" [title]="appointment.reason">
						{{ appointment.reason }}
					</td>
					<td class="py-3 px-4">
						<button *ngIf="canCancelAppointment(appointment)" (click)="cancelAppointment(appointment.id)"
							class="cursor-pointer px-3 py-1 text-xs font-medium text-red-600 rounded bg-red-100 hover:bg-red-200 transition-colors mr-2">
							Annuler
						</button>
						<!-- <button  (click)="payAppointment(appointment)" *ngIf="appointment.status!='cancelled'"
							class="cursor-pointer px-3 py-1 text-xs font-medium text-blue-600 rounded bg-blue-100 hover:bg-blue-200 transition-colors">
							Payer
						</button> -->
					</td>
				</tr>
			</tbody>
		</table>
	</div>

	<!-- Pagination -->
	<div class="flex flex-col sm:flex-row justify-between items-center gap-4 mt-6">
		<div class="text-sm text-gray-600 dark:text-gray-400">
			Affichage de {{ (currentPage - 1) * itemsPerPage + 1 }} à {{ Math.min(currentPage * itemsPerPage, totalItems) }}
			sur {{ totalItems }} résultats
		</div>

		<div class="flex items-center space-x-1">
			<button
				class="px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-l-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
				[disabled]="currentPage === 1" (click)="changePage(currentPage - 1)">
				<svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
					<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
				</svg>
			</button>

			<button *ngFor="let page of pages" class="px-3 py-2 text-sm font-medium border border-gray-300 hover:bg-gray-50"
				[class]="page === currentPage ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-gray-700'"
				(click)="changePage(page)">
				{{ page }}
			</button>

			<button
				class="px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-r-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
				[disabled]="currentPage === totalPages" (click)="changePage(currentPage + 1)">
				<svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
					<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
				</svg>
			</button>
		</div>
	</div>

	<!-- Empty state -->
	<div *ngIf="!loading && paginatedAppointments.length === 0" class="text-center py-12">
		<div class="max-w-md mx-auto">
			<svg class="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
				<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
					d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
			</svg>
			<h3 class="mt-2 text-sm font-medium text-gray-900 dark:text-white">Aucun rendez-vous</h3>
			<p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
				Aucun rendez-vous trouvé pour les critères sélectionnés.
			</p>
		</div>
	</div>
</div>